import GeneralInformationContainer from './GeneralInformationContainer';

export default GeneralInformationContainer;
